/* global G */
import { get, set } from 'lib/sequence/component/state/value'
import listCountries from 'app/_shared/events/collection/listCountries'
import { getFirstItem } from 'lib/util'

/**
 * Finds the current language of the user and presets the country field accordingly
 * if the field has no value.
 *
 * This allows us to execute {@link initAddress} afterward in a create form.
 *
 * @param {Gaia.AppModule.Spec} module current module composition
 * @returns {function(*, ...[*]): Promise<*[]>}
 */
export default module => async (components, ...args) => {
  const actionComponent = module[G.STATE][G.ACTION][G.COMPONENT]
  const { country } = components

  const sessionState = module[G.ADAPTER][G.SESSION][G.STATE]
  const userOrganisation = getFirstItem(sessionState[G.META]?.refs?.organisation || [{}])
  const userCountry = userOrganisation?.value?.address?.country

  const targetCountry = userCountry
    ? getFirstItem(listCountries(module, actionComponent, { detail: { key: userCountry } }))
    : null

  country
  && !get(country)
  && targetCountry
  && set(country, [{ key: targetCountry.key, value: targetCountry.value }])

  return [components, ...args]
}
